import type { FaireProductEntity } from "../../entity_types/product";

export const p_hzedjzu9zb: FaireProductEntity = {
  token: "p_hzedjzu9zb",
  type: "product",
  name: "Aromatic Candle Mix & Match Bundle (12 Pack)",
  brandToken: "b_2g8zsudmn8",
  brandName: "Votivo",
  imageUrl:
    "https://cdn.faire.com/fastly/b919a44dde6242cccc00b06a67b168e24d64d3d6f7276db51f709734ab6a96f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/113d8146d6d79bdbf76c2851e54fe7e06774acf038a77f6b7e1864c795e1eb29.jpeg",
    "https://cdn.faire.com/fastly/dc706f1ee039023096aa16d663db1b5dcb5f03a85c2bf0300cbdef7c8952252b.jpeg",
    "https://cdn.faire.com/fastly/6554ca9dbfe79cec37ca6bd0701d6894adf32bb92af17e056361d5f1fde30283.jpeg",
    "https://cdn.faire.com/fastly/dc0a36b68630565c723c481307b7ddd70f7fcaf3edc3c042445aaaee5b22386b.jpeg",
    "https://cdn.faire.com/fastly/a1a9000648dc1b2ace94bd383a882ec5cacbf665f66e3d1e3446b5e71151d5fd.jpeg",
    "https://cdn.faire.com/fastly/5056f63ed9997abcfcb5f54cc50322bbd753613678eca23d6b917e848ce4a845.jpeg",
    "https://cdn.faire.com/fastly/edc1507f84a6a8a6e5c823828ff12e0777dd270e9219bded7f57600626d02898.jpeg",
    "https://cdn.faire.com/fastly/fc6643b4567ccc8f7cd71402ba3e3d5eb7d4d4da0ad4ac02bc00f7639203c213.jpeg",
    "https://cdn.faire.com/fastly/c410db863df5eed9d3b3a62e2821cf89a02e2fbacdac9906c3ca479eef51d3b9.jpeg",
    "https://cdn.faire.com/fastly/cb7f94424965dcb765ee680b2f6fbce7e433c419284bf6aef5320ea8471ece83.jpeg",
    "https://cdn.faire.com/fastly/8ce541cf1e9c6eb85fbfc7514ba13ad1c4fcb389862f87c2dd89d263aaee8303.jpeg",
    "https://cdn.faire.com/fastly/68682ab04fd95cae8f51ef351377b203d92c5208a8da573d263db5d48f4a85d6.jpeg",
    "https://cdn.faire.com/fastly/288bae3ac5c5ae518c664aeae93849d1aecd94d0777cb0ed5ef2faff7f6f3486.jpeg",
  ],
  priceDollars: 17,
  description:
    "Mix and Match your choice of 12 - 6.8 Votivo Aromatic Candles.\n\nThe 6.8 oz Aromatic Candle is brimming with one-of-a-kind fragrance. Every Votivo candle is meticulously crafted with a proprietary soy-blend wax formulation that ensures a clean, even burn and a memorable, one-of-a-kind fragrance experience.",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:11.237Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
